import SessionService from "../../../../../../services/session/SessionService";
import { Clock } from "../../../overview/components/clock/Clock";
import { Weather } from "../../../overview/components/weather/Weather";
import { BorderLeftBlock, BorderLeftCircle, BorderLine, BorderRightLine, BorderRightCircle, NavigateItem, NavigateItems, NavigatorCenter, NavigatorLeft, NavigatorRight, NavigatorWrapper, ScreenTitle, ScreenTitleCn, ScreenTitleEn, TitleBorder, BorderRightBlock, NavigateItemSeparator } from "./Navigator.styled";

interface NavigatorProps {
    selected?: string
}

let Navigator: React.FC<NavigatorProps> = (props)=> {
    let tenantNo = SessionService.getInstance().getCurrentUserProfile().tenantNo;
    let title = {
        cn: "智能卷扬机互联系统",
    };
    if (tenantNo == 'RTZB') {
        title = {
            cn: "电动轮智能监测互联系统",
        };
    };

    return (
        <NavigatorWrapper>
            <NavigatorLeft>
                <img src='/static/images/big-screen/v1/winch-illustration.png' style={{width: '45px', height: '45px', margin: '0px 20px'}} />
                <ScreenTitle>
                    <ScreenTitleCn>{title.cn}</ScreenTitleCn>
                </ScreenTitle>
            </NavigatorLeft>

            <NavigatorCenter>
                <NavigateItems>
                    <NavigateItem href={SessionService.getInstance().getCurrentUserProfile().admin ? "/#/" : '#'}>管理控制台</NavigateItem>
                    <NavigateItemSeparator />
                    <NavigateItem href="/#/big-screen/overview" className={props.selected=='OVERVIEW' ? "selected" : "" }>系统总览</NavigateItem>
                    <NavigateItemSeparator />
                    <NavigateItem className={props.selected=='DEVICE_DETAILS' ? "selected" : "" }>设备详情</NavigateItem>
                </NavigateItems>
                
            </NavigatorCenter>

            <NavigatorRight>
                <Weather />
                <Clock />
            </NavigatorRight>

            
            <TitleBorder>
                <BorderLeftCircle />
                <BorderLeftBlock />
                <BorderLine />
                <BorderRightLine />
                <BorderRightBlock />
                <BorderRightCircle />
            </TitleBorder>
            


        </NavigatorWrapper>
    )
};

export default Navigator;
